
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/commercial-combined-business/[promotionSlug]",
      function () {
        return require("private-next-pages/personal/commercial-combined-business/[promotionSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/commercial-combined-business/[promotionSlug]"])
      });
    }
  